import { gql, useMutation, useQuery } from '@apollo/client'

import {
  PrivacySettingsQuery,
  PrivacySettingsQueryVariables,
  PrivacySettingsType,
  UpdateUserPrivacySettingsMutation,
  UpdateUserPrivacySettingsMutationVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<
    PrivacySettingsQuery,
    PrivacySettingsQueryVariables
  >(QUERY)

  const [updateUserPrivacySettings] = useMutation<
    UpdateUserPrivacySettingsMutation,
    UpdateUserPrivacySettingsMutationVariables
  >(UPDATE_USER_PRIVACY_SETTINGS)

  return {
    state: {
      checked: !!data?.user?.settings?.privacy?.item,
    },
    actions: {
      async onChange() {
        await updateUserPrivacySettings({
          variables: {
            inputs: {
              type: PrivacySettingsType.Item,
              flag: !data?.user?.settings?.privacy?.item,
            },
          },
          optimisticResponse() {
            return {
              updateUserPrivacySettings: {
                id: data?.user?.id ?? '',
                settings: {
                  privacy: {
                    item: !data?.user?.settings?.privacy?.item,
                    __typename: 'PrivacySettings',
                  },
                  __typename: 'UserSettings',
                },
                __typename: 'User',
              },
            }
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query PrivacySettings {
    user {
      id
      settings {
        privacy {
          item
        }
      }
    }
  }
`

const UPDATE_USER_PRIVACY_SETTINGS = gql`
  mutation UpdateUserPrivacySettings($inputs: UserPrivacySettingsInput!) {
    updateUserPrivacySettings(inputs: $inputs) {
      id
      settings {
        privacy {
          item
        }
      }
    }
  }
`
